import * as React from 'react';
import * as main from "../../main.module.scss";
import * as revs from "./style.module.scss";
import data from "./data.json";
const RevsItem = ({ elem }) => {
  const [isFullText, setIsFullText] = React.useState(false);
  return (
    <>
      { elem.avatar && <img src={elem.avatar} alt={""}/> }
      <h3>{elem.author}</h3>
      <p>
        {elem.visibleText}
        {elem.hiddenText &&
          (isFullText ? (
            <>
              {elem.hiddenText}
              <br />
              <button
                onClick={() => {
                  setIsFullText(false);
                }}>
                Свернуть
              </button>
            </>
          ) : (
            <>
              ...
              <br />
              <button
                onClick={() => {
                  setIsFullText(true);
                }}>
                Читать полностью
              </button>
            </>
          ))}
      </p>
    </>
  );
};
export const Revs = () => {
  const swiperEl = React.useRef();
  React.useEffect(() => {
    if (swiperEl.current) {
      Object.assign(swiperEl.current, {
        slidesPerView: 1,
        spaceBetween: 5,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          660: {
            slidesPerView: 2,
            spaceBetween: 20,
          },

          1100: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
        },
      });
      swiperEl.current.initialize();
    }
  }, []);
  return (
    <section className={revs.revs}>
      <div className="container" style={{ position: "unset" }}>
        <h2 className={main.title}>Отзывы экспертов и наших учеников</h2>
        <swiper-wrapper style={{ position: "relative" }}>
          <swiper-container
            ref={swiperEl}
            init="false"
            style={{
              width: "100%",
              overflowX: "hidden",
              paddingBottom: "100px",
            }}
          >
            {data.map((elem, index) => (
              <swiper-slide key={index}>
                <RevsItem elem={elem}/>
              </swiper-slide>
            ))}
          </swiper-container>
          <div className={revs.swiperButtons}>
            <button
              aria-label="swiper-button-next"
              className={`swiper-button-next ${revs.swiperButtonNext}`}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="69" height="52" viewBox="0 0 69 52" fill="none">
                <path d="M18.689 18.6689C20.446 12.9408 24.2017 8.03427 29.2722 4.84258C34.3428 1.65089 40.3909 0.386357 46.3155 1.27922C52.24 2.17209 57.6469 5.16297 61.5516 9.70728C65.4562 14.2516 67.599 20.0471 67.5898 26.0385C67.5806 32.03 65.4199 37.8188 61.5013 42.3511C57.5826 46.8833 52.1665 49.8575 46.2393 50.7321C40.312 51.6067 34.2678 50.3236 29.2071 47.1163C24.1464 43.909 20.4059 38.9909 18.6666 33.2574" stroke="#FE4C04" strokeWidth="2"/>
                <path d="M54.7071 26.7071C55.0976 26.3166 55.0976 25.6834 54.7071 25.2929L48.3432 18.9289C47.9526 18.5384 47.3195 18.5384 46.9289 18.9289C46.5384 19.3195 46.5384 19.9526 46.9289 20.3431L52.5858 26L46.9289 31.6569C46.5384 32.0474 46.5384 32.6805 46.9289 33.0711C47.3195 33.4616 47.9526 33.4616 48.3432 33.0711L54.7071 26.7071ZM-5.97298e-08 27L54 27L54 25L5.97298e-08 25L-5.97298e-08 27Z" fill="#FE4C04"/>
              </svg>
            </button>
            <button
              aria-label="swiper-button-prev"
              className={`swiper-button-prev ${revs.swiperButtonPrev}`}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="69" height="52" viewBox="0 0 69 52" fill="none">
                <path d="M49.9008 33.3311C48.1438 39.0592 44.3882 43.9657 39.3176 47.1574C34.2471 50.3491 28.1989 51.6136 22.2744 50.7208C16.3498 49.8279 10.943 46.837 7.03828 42.2927C3.1336 37.7484 0.990792 31.9529 1.00003 25.9615C1.00926 19.97 3.16992 14.1812 7.08859 9.64892C11.0073 5.11666 16.4233 2.14246 22.3506 1.26786C28.2778 0.393255 34.3221 1.67643 39.3828 4.88373C44.4434 8.09103 48.184 13.0091 49.9233 18.7426" stroke="#FE4C04" strokeWidth="2"/>
                <path d="M14.2929 25.2929C13.9024 25.6834 13.9024 26.3166 14.2929 26.7071L20.6568 33.0711C21.0474 33.4616 21.6805 33.4616 22.0711 33.0711C22.4616 32.6805 22.4616 32.0474 22.0711 31.6568L16.4142 26L22.0711 20.3431C22.4616 19.9526 22.4616 19.3195 22.0711 18.9289C21.6805 18.5384 21.0474 18.5384 20.6568 18.9289L14.2929 25.2929ZM69 25L15 25L15 27L69 27L69 25Z" fill="#FE4C04"/>
              </svg>
            </button>
          </div>
        </swiper-wrapper>
      </div>

    </section>
  );
}
